import { Card } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import NotFoundRecords from 'src/components/NotFoundRecords';
import { successSelector } from 'src/store/selectors/statusSelector';
import { LOAD_PAYMENTS_LIST } from 'src/store/actions/paymentsActions';
import AutomaticDebitCollectionTable from './AutomaticDebitCollectionTable';

const AutomaticDebitCollectionList = ({
  payments,
  count,
  page,
  handleChangePage,
  loading
}) => {
  const success = useSelector(successSelector([LOAD_PAYMENTS_LIST.action]));

  if (success && !loading && count === 0) {
    return (
      <Card>
        <NotFoundRecords
          title="NOT_FOUND_RECORDS_MESSAGE.AUTOMATIC_DEBIT_COLLECTIONS_TITLE"
          description="NOT_FOUND_RECORDS_MESSAGE.AUTOMATIC_DEBIT_COLLECTIONS_DESCRIPTION"
        />
      </Card>
    );
  }

  return (
    <AutomaticDebitCollectionTable
      payments={payments}
      count={count}
      page={page}
      handleChangePage={handleChangePage}
      loading={loading}
    />
  );
};

AutomaticDebitCollectionList.propTypes = {
  payments: PropTypes.array.isRequired,
  count: PropTypes.number,
  page: PropTypes.number,
  handleChangePage: PropTypes.func.isRequired,
  loading: PropTypes.bool
};

AutomaticDebitCollectionList.defaultProps = {
  count: 0
};

export default AutomaticDebitCollectionList;
